// import axios from "axios";
import { axiosInstance } from "../config/axios";

export const getProductLogs = async (
  scraper_id,
  action_type,
  page,
  page_size,
  scraper_run_id,
  search
) => {
  const res = await axiosInstance.get("/product_logs", {
    params: {
      scraper_id: scraper_id,
      page: page,
      page_size: page_size,
      action_type: action_type,
      scraper_run_id,
      search,
    },
  });
  console.log("=====================RES", res);
  return res;
};

export const getScraperLogs = async (page, page_size) => {
  const res = await axiosInstance.get("/scraper_logs", {
    params: {
      page,
      page_size,
    },
  });
  return res;
};

export const getScraperReportCards = async (scraper_run_id) => {
  const res = await axiosInstance.get("/scraper-report-card", {
    params: { scraper_run_id },
  });

  return res;
};
